
export class FineAmount {
    id: string;
    amount: number;
}
